import { render, staticRenderFns } from "./LeaderboardNew.vue?vue&type=template&id=2c27866a&scoped=true&"
import script from "./LeaderboardNew.vue?vue&type=script&lang=js&"
export * from "./LeaderboardNew.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardNew.vue?vue&type=style&index=0&id=2c27866a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27866a",
  null
  
)

export default component.exports